/**
* The module used for handling errors.
* @module abt-utils/logger
*/

import _ from 'lodash'
import eventManager from 'eventmanager'
import debugMode from './debug-mode'

/**
 * Logs an error to the event manager.
 * This is typically used as an error handler for the catch block of Promise chains.
 * @param {error|object|string} err - The error that was thrown.
 */
export function error (err) {
  _write('error', ['ABT:', err])
}

/** Logs a warning if the user is in dev mode. */
export function warn () {
  _write('warn', _.toArray(arguments))
}

/** Logs an info message if the user is in dev mode. */
export function info () {
  _write('info', _.toArray(arguments))
}

/** Logs a message if the user is in dev mode. */
export function log () {
  _write('log', _.toArray(arguments))
}

/**
 * Only logs a message if the user is in dev mode.
 * @param {string} method - how to log the message (i.e. 'log', 'info', 'warn', 'error').
 * @param {array} args - the arguments to pass to the event manager or console method.
 */
function _write (method, args) {
  if (!isVerbose() && method !== 'error') return

  var logWriter = debugMode.exists() ? eventManager : console
  logWriter[method].apply(undefined, args)
}

/**
 * Detects if verbose logging is enabled.
 * @returns {boolean} whether or not verbose logging is enabled.
 */
export function isVerbose () {
  return window.localStorage.abtestdev === 'true'
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-utils/logger.js
 ** module id = 1
 ** module chunks = 2 3
 **/